import Vue from 'vue';
import clonedeep from 'lodash.clonedeep';
import prototype from './ConfirmModal.vue';

const ConfirmModalConstructor = Vue.extend(clonedeep(prototype));

let instance;

const ConfirmModal = (options) => {
  if (!instance) {
    instance = new ConfirmModalConstructor();

    instance.vm = instance.$mount();
    document.body.appendChild(instance.vm.$el);
    instance.dom = instance.vm.$el;
  }

  instance.vm.title = options.title;
  instance.vm.message = options.message;

  if (options.cancelLabel) {
    instance.vm.cancelLabel = options.cancelLabel;
  }

  if (options.confirmLabel) {
    instance.vm.confirmLabel = options.confirmLabel;
  }

  if (options.confirmButtonClass) {
    instance.vm.confirmButtonClass = options.confirmButtonClass;
  }

  instance.vm.open();

  return new Promise((resolve, reject) => {
    instance.vm.reject = (error) => {
      reject(error);
    };

    instance.vm.resolve = () => resolve();
  });
};

export default ConfirmModal;
